export default "__VITE_ASSET__11949aa3__"